<template>
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    ></loading>
  </div>
  <vue-final-modal
    v-model="deleteModal"
    classes="flex justify-center items-center"
    :ssr="true"
    content-class="relative h-auto max-h-5/6 flex flex-col mx-4 md:mx-0 pt-2 pb-4 border dark:border-gray-800   bg-white dark:bg-gray-900 w-full md:w-1/2 lg:w-1/3"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <jb-button
      class="absolute top-1 right-1 z-20 rounded-lg dark:bg-gray-800 dark:text-white dark:border-gray-700"
      :icon="mdiClose"
      @click="deleteModal = false"
    >
    </jb-button>
    <div class="space-y-3 pb-3 pl-4 z-10 shadow-lg dark:shadow-gray-200">
      <h1 class="text-2xl">{{ $t("confirmDelete.title") }}</h1>
      <slot />
    </div>
    <div class="w-full px-4 py-6">
      <p>{{ $t("confirmDelete.message") }}</p>
    </div>
    <jb-buttons class="flex justify-center w-full">
      <jb-button label="Confirm" color="info" @click="confirm" class="w-1/2">
      </jb-button>
      <jb-button
        label="Cancel"
        color="danger"
        outline
        @click="cancel"
        class="w-2/5"
      >
      </jb-button>
    </jb-buttons>
  </vue-final-modal>

  <card-component
    class="mt-2 content-center"
    :title="$t('comboardrecipients.title')"
    :icon="mdiReceiptTextMinus"
    has-table
  >
    <form
      @submit.prevent="storeEmployee"
      class="w-full md:w-1/2 mx-auto h-full content-center"
    >
      <!-- Department -->
      <div class="flex flex-wrap mb-4 content-center">
        <p class="w-full mb-1">Department</p>
        <multiselect
          :options="departmentOptions"
          label="name"
          track-by="value"
          mode="tags"
          v-model="filterEmployee.department_id"
          :placeholder="$t('department.title')"
          @select="
            (opt) =>
              handleSelectAll(
                opt,
                filterEmployee['department_id'],
                departmentOptions,
                'department_id'
              )
          "
          @remove="
            (opt) =>
              handleSelectAll(
                opt,
                filterEmployee['department_id'],
                departmentOptions,
                'department_id'
              )
          "
        />
      </div>

      <!-- Workunit -->
      <div class="flex flex-wrap mb-4 content-center">
        <p class="w-full mb-1">Workunit</p>
        <multiselect
          :options="workunitOptions"
          label="name"
          track-by="value"
          mode="tags"
          v-model="filterEmployee.workunit_id"
          :disabled="!filterEmployee.department_id.length"
          placeholder="Select Workunit"
          @select="
            (opt) =>
              handleSelectAll(
                opt,
                filterEmployee['workunit_id'],
                workunitOptions,
                'workunit_id'
              )
          "
          @remove="
            (opt) =>
              handleSelectAll(
                opt,
                filterEmployee['workunit_id'],
                workunitOptions,
                'workunit_id'
              )
          "
        />
      </div>

      <!-- Employee -->
      <div class="flex flex-wrap mb-4 content-center">
        <p class="w-full mb-1">Employee</p>
        <multiselect
          :options="employeeOptions"
          label="name"
          track-by="value"
          mode="tags"
          v-model="filterEmployee.employee_id"
          :disabled="!filterEmployee.workunit_id.length"
          placeholder="Select Employee"
          @select="
            (opt) =>
              handleSelectAll(
                opt,
                filterEmployee['employee_id'],
                employeeOptions,
                'employee_id'
              )
          "
          @remove="
            (opt) =>
              handleSelectAll(
                opt,
                filterEmployee['employee_id'],
                employeeOptions,
                'employee_id'
              )
          "
        />
      </div>

      <!-- Buttons -->
      <jb-buttons class="flex flex-nowrap justify-center w-full">
        <jb-button
          type="submit"
          color="info"
          :icon="mdiCheckBold"
          label="Submit"
          class="w-3/5 md:w-auto md:px-8"
        />
        <jb-button
          type="reset"
          color="info"
          :icon="mdiRefresh"
          outline
          label="Reset"
          class="w-3/5 md:w-auto md:px-8"
          @click="reset"
        />
      </jb-buttons>
    </form>
  </card-component>
  <card-component
    class="mt-2 content-center"
    :title="$t('comboardrecipients.title')"
    :icon="mdiReceiptTextMinus"
    has-table
  >
    <ag-grid-vue
      style="width: 100%; height: 70vh; margin-top: 40px"
      class="ag-theme-alpine"
      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      v-text-v-html="keyData"
      :pagination="true"
      :context="context"
      @grid-ready="onGridReady"
      :rowData="rowData"
    />
  </card-component>
</template>

<script>
/* eslint-disable */
import { ref, reactive, computed, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import Multiselect from "@vueform/multiselect";
import CardComponent from "@/components/CardComponent";
import JbButtons from "@/components/JbButtons";
import JbButton from "@/components/JbButton";
import axios from "axios";
import { useToast } from "vue-toastification";

import { mdiCheckBold, mdiReceiptTextMinus, mdiRefresh } from "@mdi/js";

import { AgGridVue } from "ag-grid-vue3";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "@vuepic/vue-datepicker/dist/main\.css";

import { getWorkunit, getEmployeeData } from "@/composables/global";

export default {
  components: {
    Multiselect,
    CardComponent,
    JbButtons,
    JbButton,
    AgGridVue,
    Loading,
  },
  props: {
    departmentListFilter: {
      type: Array,
      default: () => [],
    },
    propComboards: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["close-modal", "submit", "click-refresh"],
  setup(props, { emit }) {
    const { t } = useI18n();
    const isLoading = ref(false);
    const toast = useToast();
    /* ================= STATE ================= */
    const filterEmployee = reactive({
      department_id: [],
      workunit_id: [],
      employee_id: [],
    });

    const userlogin = localStorage.getItem("username");

    const { workunitList, getDataWorkUnit } = getWorkunit();
    const { employeeList, getDataEmployee } = getEmployeeData();

    /* ================= OPTIONS ================= */
    const departmentOptions = computed(() => {
      if (!props.departmentListFilter.length) return [];
      return [...props.departmentListFilter];
    });

    const workunitOptions = computed(() => {
      if (!workunitList.value.length) return [];
      return [
        { name: "Select All", value: "__all__" },
        ...workunitList.value.map((emp) => ({
          value: emp.id,
          name: emp.name,
        })),
      ];
    });

    const employeeOptions = computed(() => {
      if (!employeeList.value.length) return [];
      return [
        { name: "Select All", value: "__all__" },
        ...employeeList.value.map((emp) => ({
          value: emp.id,
          name: emp.name,
        })),
      ];
    });

    /* ================= METHODS ================= */
    // const handleSelectAll = (option, selectedRef, listRef, field) => {
    //   if (option === "__all__") {
    //     const isAllSelected = selectedRef.length === listRef.length - 1;
    //     console.log("isAllSelected", isAllSelected);
    //     selectedRef = isAllSelected
    //       ? []
    //       : listRef
    //           .filter((opt) => opt.value !== "__all__")
    //           .map((opt) => opt.value);
    //   }

    //   if (field == "department_id") {
    //     filterEmployee[field] = [...selectedRef];
    //     getDataWorkUnit({
    //       department_ids: filterEmployee[field],
    //     });
    //   }

    //   if (field == "workunit_id") {
    //     filterEmployee[field] = [...selectedRef];
    //     getDataEmployee({
    //       work_unit_ids: filterEmployee[field],
    //     });
    //   }
    // };

    const handleSelectAll = (option, selectedRef, listRef, field) => {
      if (option === "__all__") {
        const allValues = listRef
          .filter((opt) => opt.value !== "__all__")
          .map((opt) => opt.value);

        const isAllSelected = selectedRef.length === allValues.length;
        filterEmployee[field] = isAllSelected ? [] : allValues;
      } else {
        filterEmployee[field] = [...selectedRef];
      }

      if (field === "department_id") {
        getDataWorkUnit({ department_ids: filterEmployee.department_id });
      }

      if (field === "workunit_id") {
        getDataEmployee({ work_unit_ids: filterEmployee.workunit_id });
      }
    };

    const rowData = ref([]);
    const columnDefs = [
      { headerName: "#", valueGetter: "node.rowIndex+1", width: 60 },
      {
        field: "employee_name",
        headerName: "Employee",
        sortable: true,
        filter: true,
      },
      {
        field: "info",
        headerName: "Invitation",
        sortable: true,
        filter: true,
        width: 300,
        cellRenderer: function (params) {
          let keyData = params.data.info;
          return keyData;
        },
      },
      {
        field: "work_unit_name",
        headerName: "Workunit",
        sortable: true,
        filter: true,
      },
      {
        field: "department_name",
        headerName: "Department",
        sortable: true,
        filter: true,
      },

      {
        field: "work_unit_name",
        headerName: "Workunit",
        sortable: true,
        filter: true,
      },

      {
        field: "created_at",
        headerName: "Date Created",
        sortable: true,
        filter: true,
      },
      {
        field: "id",
        headerName: t("main.action"),
        sortable: true,
        filter: true,
        minWidth: 165,
        cellRendererFramework: "ButtonRecipients",
      },
    ];
    const defaultColDef = {
      resizable: true,
    };

    const refresh = async () => {
      isLoading.value = true;
      await axios
        .get("comboard-recipients-employee", {
          params: {
            comboard_id: props.propComboards.comboard_id,
          },
        })
        .then((response) => {
          rowData.value = response.data.data;
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error, { timeout: 5000 });
          isLoading.value = false;
        });
    };

    const storeEmployee = async () => {
      isLoading.value = true;
      const url = "comboard-recipients-employee";
      const method = "POST";
      filterEmployee.created_by = userlogin;
      const dataSubmit = {
        department_ids: [...filterEmployee.department_id],
        workunit_ids: [...filterEmployee.workunit_id],
        employee_ids: [...filterEmployee.employee_id],
        comboard_id: props.propComboards.comboard_id,
        created_by: userlogin,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      };

      axios
        .post(url, dataSubmit, config)
        .then((response) => {
          if (response.data.success) {
            toast.success(response.data.message);
            isLoading.value = false;
          } else {
            errors.value = response.data.messages;
            toast.error(response.data.messages);
          }
          reset();
          refresh();
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    const reset = () => {
      filterEmployee.department_id = [];
      filterEmployee.workunit_id = [];
      workunitList.value = [];
      employeeList.value = [];
    };

    const deleteModal = ref(false);

    const confirm = () => confirmDelete();
    const cancel = () => (deleteModal.value = false);

    const deleteModalShow = (value) => {
      deleteModal.value = true;
      deleteModal.id = value.id;
    };

    const confirmDelete = () => {
      axios
        .delete(`comboard-recipients-employee/${deleteModal.id}`)
        .then((response) => {
          if (response.data.success) {
            refresh();
            deleteModal.value = false;
            toast.success(response.data.message, { timeout: 5000 });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    /* ================= WATCHERS ================= */

    // department → fetch workunit + reset workunit
    watch(
      () => filterEmployee.department_id,
      (val) => {
        filterEmployee.workunit_id = [];

        if (!val.length) {
          workunitList.value = [];
          return;
        }

        getDataWorkUnit({
          department_ids: val,
        });
      },
      { deep: true }
    );

    watch(
      () => filterEmployee.workunit_id,
      (val) => {
        filterEmployee.employee_id = [];

        if (!val.length) {
          employeeList.value = [];
          return;
        }

        getDataEmployee({
          work_unit_ids: val,
        });
      },
      { deep: true }
    );

    /* -----------------------
   WATCH
----------------------- */
    watch(
      () => props.propComboards?.comboard_id,
      (newVal, oldVal) => {
        if (newVal && newVal !== oldVal) {
          refresh();
        }
      },
      { immediate: true }
    );

    onMounted(() => {
      // refresh();
    });

    /* ================= RETURN ================= */
    return {
      t,
      filterEmployee,

      departmentOptions,
      workunitOptions,
      employeeOptions,

      handleSelectAll,
      storeEmployee,
      reset,

      mdiCheckBold,
      mdiReceiptTextMinus,
      mdiRefresh,

      columnDefs,
      defaultColDef,
      rowData,
      isLoading,

      deleteModal,
      deleteModalShow,
      confirm,
      cancel,
    };
  },
  beforeMount() {
    this.context = {
      componentParent: this,
    };
  },
};
</script>
